import { combineReducers } from 'redux';

import data from './data';
import coordenades from './coordenades';
import altitud from './altitud';
import idVigilant from './idVigilant';
import idMeteorSeleccionat from './idMeteorSeleccionat';
import valors from './valors';

export default combineReducers({
    data,
    coordenades,
    altitud,
    idVigilant,
    idMeteorSeleccionat,
    valors
});



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/dades/index.js